import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'volunteering-prospects-tab-2-part',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './volunteering-prospects-tab-2.part.html',
})

export class VolunteeringProspectsTab2Part {
}
